import React, { Component } from 'react';
import moment from 'moment';

import CityForm from './CityForm'
import { defaultSorter, dateSorter } from './Helpers';
import CityModel from './CityModel'
import UserModel from './UserModel'

import { Table, Popconfirm, Divider, Typography, Tooltip, message, Row, Col, List } from 'antd';

class CityTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
        citySettingsFormData: null,
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    expandedRowRender(record) {
        return (
            <div>
                <Row>
                    <Col span={8}>
                        <List size="small"
                            header={<div>Parkoviště</div>}
                            bordered
                            dataSource={record.locationsNames}
                            renderItem={item => <List.Item>{item.parkingLocationName}</List.Item>}
                        />
                    </Col>
                </Row>
            </div >
        );
    }

    render() {
        let { sortedInfo, filteredInfo } = this.state;

        const columns = [{
            title: 'Kód',
            dataIndex: 'code',
            key: 'code',
            width: 150,
            sorter: (a, b) => defaultSorter(a.Code, b.Code),
            render: (text, rec) => {
                return <Tooltip placement="right" title={rec.id}>{text}</Tooltip>
            },
        }, {
            title: 'Název',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => defaultSorter(a.name, b.name),
            defaultSortOrder: 'ascend',
        }, {
            title: 'Akce',
            key: 'Action',
            width: 200,
            render: (text, record) => {
                if (UserModel.isInRoles(['ADMIN', 'CORE_CITIES_WRITE'])) {
                    return (
                        <div>
                            <Divider type="vertical" />
                            <a onClick={(e) => {
                                this.setState({
                                    citySettingsFormData: record
                                });
                            }}>Nastavení</a>
                            <Divider type="vertical" />
                            <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                                this.props.onRemoveRow
                                    ? this.props.onRemoveRow(record.id)
                                    : null;
                            }} okText="Ano" cancelText="Ne">
                                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
                            </Popconfirm>
                        </div>
                    );
                }
            }
        }]
        return (
            <div>
                <Table
                    size='small'
                    rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
                    loading={this.props.loading ? this.props.loading : false}
                    columns={columns}
                    onChange={this.handleChange}
                    dataSource={this.props.data}
                    expandedRowRender={this.expandedRowRender.bind(this)}
                    style={{ border: '0px' }} />
                <CityForm
                    type="modal"
                    modalVisible={this.state.citySettingsFormData === null ? false : true}
                    initialValues={this.state.citySettingsFormData}
                    onSuccess={(form, values) => {
                        CityModel.patch(this.state.citySettingsFormData.id, values)
                            .then(() => {
                                message.success("Změna byla uložena!");
                                form.resetFields();
                                this.setState({
                                    citySettingsFormData: null
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch(err => {
                                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
                            })
                    }}
                    onModalCancel={() => {
                        this.setState({ citySettingsFormData: null });
                    }}
                />
            </div>
        );
    }
}

export default CityTable;


// WEBPACK FOOTER //
// ./src/components/CityTable.js